import type { CSSObject } from 'styled-components';
import type { ExecutedStatus } from './status';
import { Status } from './status';

enum Color {
  // Gray
  Acknowledged = '#CCCCC4',
  Cancelled = '#CCCCC4',
  // Green
  Accepted = '#31B07A',
  Completed = '#31B07A',
  // Red
  Rejected = '#ED4E47',
  Declined = '#ED4E47',
  // Orange
  Paused = '#F89F40',
  Pending = '#F89F40',
  // ---
  Default = 'transparent',
}

const getColor = (status: Status): Color => {
  const enumArray = Object.keys(Color);
  const knownStatusColor = enumArray.find(enumStatus => enumStatus === status);
  if (knownStatusColor) return Color[status];
  return Color.Default;
};

const dot = (status: Status): CSSObject => {
  const dotColor = getColor(status);
  const executionStage: Array<ExecutedStatus> = [
    Status.Cancelled,
    Status.Completed,
    Status.Declined,
    Status.Pending,
  ];

  const hollowDotStyles = {
    alignItems: 'center',
    display: 'flex',

    '&:before': {
      backgroundColor: 'transparent',
      borderColor: dotColor,
      borderRadius: '.625rem',
      borderStyle: 'solid',
      borderWidth: '2px',
      content: '" "',
      display: 'block',
      marginRight: '.5rem',
      height: '.75rem',
      width: '.75rem',
    },
  };
  if (executionStage.find(execStatus => execStatus === status)) {
    const filledDot = { ...hollowDotStyles };
    filledDot['&:before'].backgroundColor = dotColor;
    return filledDot;
  }
  // "request" stage TRXs are shown as hollow dots
  return hollowDotStyles;
};

export default dot;
